const app = {
  name: "Konfigurasi Website",
  fullname: "Landing Page EPC",
  company: "EPC Energy Singapore",
  guide: "#",
  site: "#",
  code: "#",
  logo: {
    sm: "./static/img/logo/240x240.png",
    md: "./static/img/logo/480x480.png",
    lg: "./static/img/logo/720x720.png"
  },
  server: {
    local: "http://127.0.0.1:8000/api/",
    stagging: "/api/",
    development: "https://admin.epcenergysingapore.com/api/",
    production: "/api/",
    demo: "/api/"
  },
  sso: {
    stagging: "https://admin.epcenergysingapore.com/api/",
    development: "https://admin.epcenergysingapore.com/api/",
    production: "#",
    demo: "https://admin.epcenergysingapore.com/api/"
  },
  download: {
    android: "https://play.google.com/store/",
    ios: "https://www.apple.com/id/app-store/"
  },
  options: {
    allowRegister: false,
    forgetPassword: false,
    autofill: false,
    myAction: false,
    asideRight: false,
    sso: false
  }
};

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app;



// WEBPACK FOOTER //
// ./src/config.js